export const getUserDisplayName = (user: any): string => {
  if (!user) return 'Utilisateur inconnu';

  // 1. Check for entreprise_nom in profile
  if (user.profile && user.profile.entreprise_nom) {
    return user.profile.entreprise_nom;
  }

  // 2. Fallback to basic email formatting
  if (user.email) {
    // If it's a generic email without name, just return it
    return user.email.split('@')[0];
  }

  return 'Utilisateur'; // ultimate fallback
};

export const getUserInitials = (user: any): string => {
  const name = getUserDisplayName(user);
  if (name && name !== 'Utilisateur inconnu' && name !== 'Utilisateur') {
      return name.charAt(0).toUpperCase();
  }
  return 'U';
};
